<script>

    import { toast } from 'bulma-toast'
    import { replace } from 'svelte-spa-router'
    import { UserStore, SessionStore } from '../stores'

    import LocalstoreService from '../localstore'
    import UsersService from '../$services/users.service'

    import Button from '../$components/button.svelte'
    import Form from '../$components/form.svelte'
    import InputEmail from '../$components/input.email.svelte'
    import InputPassword from '../$components/input.password.svelte'
    import Image from '../$components/image.svelte'

    let loading = false
    let data = {
        email: '',
        password: ''
    }
    
    async function login() {
    
        loading = true
        const resp = await UsersService.login(data)
        loading = false
    
        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        UserStore.set(resp.data.user)
        SessionStore.set(resp.data.session)

        LocalstoreService.setItem('admin', resp.data.user)
        LocalstoreService.setItem('session', resp.data.session)

        replace('#/shipments')
    }
</script>

<style>
    .content {
        background: white;
        padding: 32px;
        border-radius: 16px;
        min-width: 25vw;
    }

    @media screen and (max-width: 400px) {
        .content {
            width: 100vw;
            border-radius: 16px 0 16px 0;
        }
    }
</style>

<div class="content">
    <Form on:submit={login} textSave="Ingresar" iconSave="sign-in-alt" hideCancel={true} { loading } >
        <div class="items center">
            <Image src="/images/brand.png" size="96x96" />
        </div>
        <hr>
        <div class="columns">
            <div class="column">
                <InputEmail bind:value={data.email} />
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <InputPassword bind:value={data.password} />
            </div>
        </div>
    </Form>
    <div class="columns">
        <div class="column">
            <Button on:click={() => replace('#/signup')} text="No tengo una cuenta" icon="user-plus" color="info" fullwidth={true} inverted={true} />
        </div>
    </div>
</div>